import { StudyInstance } from "./study-instance";
import { of } from "rxjs";
import { CMoveProgress } from "./cmove-progress";
import { Patient } from '@radsource/ng-common-lib';
import { Injectable } from '@angular/core'

@Injectable()
export class PatientInstance extends Patient {

	source_ae: string;

	//related instance objects
	studies: Array<StudyInstance>;
	studies$: any;

	//ui variables
	editTemplate: Boolean = false;
	editing: Boolean = false;
	saving: Boolean = false;
	pushing: Boolean = false;
	pushing$: any;
	transferring: Boolean = false;
	transferring$: any;
	pushAttempted: Boolean = false;
	pushAttempted$: any;
	expanded: Boolean = false;
	expanded$: any;
	percentagePushed: number = 0;
	percentagePushed$: any;

	studiesComplete: number = 0;
	studiesIncomplete: number = 0;

	pushProgress: CMoveProgress = new CMoveProgress();
	pushProgress$: any;


	//CONSTRUCTOR
	constructor();
	constructor(instance: any);
	constructor(instance?: any) {
		super(instance);
		//related instances
		this.source_ae = (instance && instance.source_ae) ? instance.source_ae : null;
		this.studies = (instance && instance.studies) ? instance.studies : new Array<StudyInstance>();
		this.studies$ = of(this.studies);
	} //end constructor

	resetAllButThumbnail(): void {
		this.pushAttempted = false;
		this.pushAttempted$ = of(this.pushAttempted);

		this.pushing = false;
		this.pushing$ = of(this.pushing);

		this.transferring = false;
		this.transferring$ = of(this.transferring);

		this.expanded = false;
		this.expanded$ = of(this.expanded);

		this.pushProgress = new CMoveProgress();
		this.pushProgress$ = of(this.pushProgress);
	}

	update(inst: PatientInstance): void {
		this.birth_date = inst.birth_date;
		this.id = inst.id;
		this.name = inst.name;
		this.record_id = inst.record_id;
		this.sex = inst.sex;
		this.source_ae = inst.source_ae
	}

	updateProgress(cmoveExists: Boolean): any {
		//reduce the studies to see patient progress
		this.studiesComplete = this.studies.filter((s) => s.percentagePushed >= 100).length;
		this.studiesIncomplete = this.studies.filter((s) => s.percentagePushed < 100).length;
		this.percentagePushed = Math.round(100 * (this.studiesComplete / this.studies.length));
		this.percentagePushed$ = of(this.percentagePushed);

		if (cmoveExists) {

			this.pushing = true;
			this.pushing$ = of(this.pushing);
	
			if (this.percentagePushed >= 100) {
				this.pushAttempted = true;
				this.pushAttempted$ = of(this.pushAttempted);
				this.transferring = false;
				this.transferring$ = of(this.transferring);
			} else {
				this.transferring = true;
				this.transferring$ = of(this.transferring);
			}
		}
	}

	essentials(): any {
		let essentials = {
			birth_date: this.birth_date,
			id: this.id,
			name: this.name,
			record_id: this.record_id,
			sex: this.sex,
			source_ae: this.source_ae
		}
		return essentials;
	}

} //end class